import React from 'react';

import Button from '@components/elements/Button';
import Carousel from '@elements/Carousel';
import { getClasses } from '@utils';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';

import './style.css';

type ButtonCTAProps = {
  __typename: string;
  contentful_id: string;
  title: string;
  ctaLink: string;
  color: string;
  position: string;
};

type ImageProps = {
  contentful_id: string;
  title: string;
  gatsbyImageData: IGatsbyImageData;
};

type ImagesliderProps = {
  item: {
    title: string;
    description: {
      description: string;
    };
    images: Array<ImageProps>;
    buttonCta: ButtonCTAProps | any;
  };
};

const ImageContainer = ({ item }: ImagesliderProps): JSX.Element => {
  const {
    title,
    description,
    images,
    buttonCta,
  } = item;

  const btnSectionClasses = getClasses(
    `btn--cta-${buttonCta?.position}`,
    `btn--cta`,
  );
  const breakpoints = {
    sm: 2,
    md: 3,
    lg: 4,
  };

  return (
    <div className='image-container--main'>
      <section className='image-container__title'>
        <hr/>
        <h2>{title}</h2>
        <p>{description?.description}</p>
      </section>
      <section className='image-container__carousel'>
        <Carousel breakpoints={breakpoints} buttonsTop>
          {images?.map((preImage: ImageProps) => {
            const image = getImage(preImage.gatsbyImageData);

            return (
              <figure key={preImage.contentful_id}>
                <GatsbyImage alt={preImage.title} image={image} />
              </figure>
            );
          })}
        </Carousel>
      </section>
      {buttonCta && (
        <section className={btnSectionClasses}>
          <Button childClassName={`btn--${buttonCta.color}`} href={buttonCta.ctaLink}>
            {buttonCta.title}
          </Button>
        </section>
      )}
    </div>
  );
};

export default ImageContainer;
